export default [{
    dataKey: 'finishDate',
    title: 'Finished date',
    sortable: true,
}, {
    dataKey: 'contentPartner',
    title: 'Content partner',
    sortable: false,
}, {
    dataKey: 'contentType',
    title: 'Content type',
    sortable: false,
}];
